import React from "react";
import { RotateSpinner } from "react-spinners-kit";
import styled from "styled-components";

function Spinner() {
  return (
    <SpinnerWrapper>
      <RotateSpinner size={60} color="#007092" />
    </SpinnerWrapper>
  );
}

const SpinnerWrapper = styled.div`
  height: 45vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Spinner;
